import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MasterJsonKeyPrefix } from '@conf/asw-master.config';
import { isNumeric } from '@lib/helpers';

@Injectable({
  providedIn: 'root',
})
export class CheckinPassengerInputValidationService {
  private static readonly ANA_COMPANY_CODE = 'NH';
  private static readonly ANA_CARD_NUMBER_LENGTH = 10;
  static readonly IS_EMAIL_DIFFERENT_ERROR_KEY = 'isEmailDifferent';

  /**
   * 個別入力チェック パスポート情報の名・ミドルネーム・姓の最大文字数を判定する
   * @param control 名・ミドルネーム・姓の入力欄
   * @returns 55文字未満:null / それ以外:{ isNameOverDigits }
   */
  nameDigitsValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const firstName = control.get('firstName')?.value || '';
    const middleName = control.get('middleName')?.value || '';
    const lastName = control.get('lastName')?.value || '';
    const totalLength = firstName.length + middleName.length + lastName.length;

    return totalLength > 60 ? { isNameOverDigits: true } : null;
  };

  /**
   * 個別入力チェク FFP情報のANAマイレージプログラムとマイレージ番号組み合わせを判定する
   * @param control マイレージプログラムとマイレージ番号の入力欄
   * @returns 一致 null / 不一致 { isMileageCardNumberDigitError }
   */
  mileageCardNumberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const companyCode = control.get('companyCode')?.value || '';
    const cardNumber = control.get('cardNumber')?.value || '';
    let error = '';

    if (cardNumber.length) {
      if (companyCode === CheckinPassengerInputValidationService.ANA_COMPANY_CODE) {
        if (
          !isNumeric(cardNumber) ||
          cardNumber.length !== CheckinPassengerInputValidationService.ANA_CARD_NUMBER_LENGTH
        ) {
          error = 'E0659';
        } else {
          const uniqueNumber = +cardNumber.slice(0, 9);
          const checkDigit = +cardNumber.slice(9);
          const remain = uniqueNumber % 7;

          if (remain + 1 !== checkDigit) {
            error = 'E0660';
          }
        }
      }
    }

    return error ? { isMileageCardNumberDigitError: error } : null;
  };

  /**
   * 個別入力チェック 連絡先情報のメールアドレスと確認用メールアドレスの一致を判定する
   * @param control メールアドレスと確認用メールアドレスの入力欄
   * @returns 一致 null / 不一致 { isEmailDifferent }
   */
  emailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const email = control.get('email');
    const confirmEmail = control.get('confirmEmail');

    // 両方の値が入力されていて、かつ一致しない場合エラーを表示
    return email?.value && confirmEmail?.value && email.value !== confirmEmail.value
      ? {
          [CheckinPassengerInputValidationService.IS_EMAIL_DIFFERENT_ERROR_KEY]: {
            errorMsgId: 'E0017',
            params: { key: 0, value: `${MasterJsonKeyPrefix.STATIC}label.confirmMailAddress` },
          },
        }
      : null;
  };
}
